module.exports = __webpack_public_path__ + "img/courses-4.d0454a1c.jpg";